import React from 'react';
import {observer} from "mobx-react/index";
import {toJS} from "mobx/lib/mobx";
import DragAndDrop from "../../DragAndDrop";

export const ExportFieldSelect = observer(({availableFields, selectedFields, onChangeField}) => {
  return (
    <div style={{height: '70vh', width: '50vw', overflowY: 'auto'}}>
      <DragAndDrop
        lists={[
          {
            id: 1,
            name: 'Available Fields',
            items: toJS(availableFields),
          },
          {
            id: 2,
            name: 'Selected Fields',
            // dndItems: metaDataItems,
            items: toJS(selectedFields),
            // items: [
            // // { id: 999, name: 'Dummy' },
            // ],
          },
        ]}
        onChange={onChangeField}
      />
    </div>
  );
});




// WEBPACK FOOTER //
// ./src/components/Folder/StationExport/ExportFieldSelect.js